module.exports = __webpack_public_path__ + "media/images/top-page_reserve@2x-58196e8aba9b6d30e6e8543963077349.jpg";